// SEOメタデータ管理

export const seoMeta = {
  // トップページ
  '/': {
    title: '反響成約マスター | 不動産ポータル反響を成約するクロージング3.0',
    description: '反響対応の仕組みを体系化し、成約率を最大化する最新メソッド。不動産ポータル反響から確実に成約へつなげる実践的ノウハウを無料公開。',
    keywords: '不動産反響成約,クロージング3.0,ポータル反響,成約率向上,不動産営業'
  },
  
  // 反響成約マスタートップ
  '/master': {
    title: '反響成約マスター | 体系的な成約率向上プログラム',
    description: '反響成約率を3倍にする体系的なノウハウ。初回面談、物件案内、クロージングまで、実践的な手法を無料資料で公開。87%の成約率を実現した方法とは。',
    keywords: '反響成約マスター,成約率向上,不動産営業研修,反響成約ノウハウ'
  },
  
  // 反響成約ラボ
  '/master/lab': {
    title: '反響成約ラボ | 実践ノウハウ記事集 | 反響成約マスター',
    description: '反響成約で成果を出すための実践的なノウハウ記事集。初回面談の改善、物件案内の極意、フォローアップ術、クロージング手法まで、現場で使える情報満載。',
    keywords: '反響成約ラボ,不動産営業ノウハウ,面談術,クロージング,物件案内'
  },
  
  // 資料ダウンロード一覧
  '/master/download': {
    title: '無料資料ダウンロード | 反響成約マスター',
    description: '反響成約率を上げる実践資料を無料ダウンロード。魔法の一言集、面談シート、質問術など、すぐに使えるテンプレートとノウハウを提供。',
    keywords: '不動産営業資料,無料ダウンロード,営業テンプレート,面談シート'
  },
  
  // 購入仲介とは
  '/master/about': {
    title: '購入仲介とは？用語解説 | 反響成約マスター',
    description: '購入仲介・購入専任媒介など、不動産購入仲介に関する専門用語をわかりやすく解説。基礎知識から実践的な用語まで、営業活動に役立つ情報を網羅。',
    keywords: '購入仲介とは,購入専任媒介,不動産用語,用語解説'
  },
  
  // 購入仲介用語集
  '/master/glossary': {
    title: '購入仲介用語集 | 不動産専門用語解説 | 反響成約マスター',
    description: '不動産購入仲介業務で使われる専門用語30語を詳しく解説。購入仲介、事前審査、重要事項説明など、実務で必要な用語を網羅。',
    keywords: '不動産用語集,購入仲介用語,専門用語解説,不動産業界用語'
  },
  
  // 各ホワイトペーパー
  '/master/download/wp01': {
    title: '「検討します」を「申し込みます」に変える魔法の一言 | 無料ダウンロード',
    description: '購入検討者の心理を理解し、クロージング率を3倍にする実践的テクニック。10ページの無料資料で、成約率を劇的に改善する方法を公開。',
    keywords: 'クロージング術,魔法の一言,成約率向上,不動産クロージング'
  },
  
  '/master/download/wp02': {
    title: '初回面談30分で専任媒介を獲得する面談シート | 無料ダウンロード',
    description: '成功率87%の面談手法を完全公開。時間配分から質問の流れまで、12ページの実践的な面談シートテンプレートを無料提供。',
    keywords: '面談シート,初回面談,専任媒介獲得,不動産面談術'
  },
  
  '/master/download/wp03': {
    title: '年収を聞かずに予算を把握する7つの質問術 | 無料ダウンロード',
    description: 'お客様との関係を壊さずに正確な予算を把握する心理テクニック。11ページの資料で、デリケートな質問を上手に行う方法を解説。',
    keywords: '予算把握,質問術,顧客心理,不動産営業テクニック'
  },
  
  '/master/download/wp04': {
    title: '購入検討者の心理段階別アプローチ法 | 無料ダウンロード',
    description: 'お客様の心理状態を5段階で見極め、最適なタイミングで提案する方法。15ページの資料で段階別の具体的なアプローチ手法を解説。',
    keywords: '心理段階,顧客心理分析,段階別アプローチ,購入検討者'
  },
  
  '/master/download/wp05': {
    title: '成約率を上げる物件案内チェックリスト | 無料ダウンロード',
    description: 'プロが実践する物件案内の極意。案内前・案内中・案内後の完全ガイド。18ページのチェックリストで、物件案内の成功率を大幅アップ。',
    keywords: '物件案内,チェックリスト,内見,不動産案内'
  },
  
  '/master/download/wp06': {
    title: '購入申込を獲得する交渉術 | 無料ダウンロード',
    description: '売主・買主の間で三方よしを実現する価格交渉とクロージングの極意。20ページの資料で、成功する交渉術を完全マスター。',
    keywords: '価格交渉,購入申込,交渉術,不動産交渉'
  },
  
  '/master/download/wp07': {
    title: '「他社も見ています」と言われた時の切り返し話法20選 | 無料ダウンロード',
    description: '競合に負けない心理テクニックと信頼構築の極意。14ページの資料で、競合対策の切り返し話法を完全マスター。',
    keywords: '競合対策,切り返し話法,心理テクニック,信頼構築'
  },
  
  '/master/download/wp08': {
    title: '内見後に音信不通になった客を復活させる3通のLINE | 無料ダウンロード',
    description: '心理学に基づいた復活率78%のメッセージ術。12ページの資料で、音信不通客を復活させる具体的なLINE文面を公開。',
    keywords: 'フォローアップ,LINE営業,音信不通対策,復活率向上'
  },
  
  '/master/download/wp09': {
    title: 'ローン事前審査を初回面談で通す5ステップ | 無料ダウンロード',
    description: '成功率85%の時短営業術。13ページの資料で、初回面談での事前審査成功法を完全解説。',
    keywords: 'ローン事前審査,初回面談,時短営業,効率化'
  },
  
  '/master/download/wp10': {
    title: '内見3件以内で決める！事前ヒアリング完全ガイド | 無料ダウンロード',
    description: '効率的な物件案内で成約率90%を実現。14ページの資料で、事前ヒアリングの極意を公開。',
    keywords: '事前ヒアリング,内見効率化,物件案内,成約率向上'
  },
  
  '/master/download/wp11': {
    title: '購入申込書の記入率を80%に上げる心理テクニック | 無料ダウンロード',
    description: 'その場で決断させる極意と実践的アプローチ。14ページの資料で、申込書記入率向上の秘訣を公開。',
    keywords: '購入申込書,記入率向上,心理テクニック,クロージング'
  },
  
  '/master/download/wp12': {
    title: '仲介手数料半額と言われた時の価値の伝え方 | 無料ダウンロード',
    description: '価格競争に巻き込まれない差別化戦略。14ページの資料で、正規手数料で選ばれる方法を解説。',
    keywords: '仲介手数料,価格競争,差別化戦略,価値提供'
  },
  
  '/master/download/wp13': {
    title: 'ポータルからの反響を来店に繋げる返信テンプレート集 | 無料ダウンロード',
    description: '反響からの来店率を3倍にする実践的メール術。14ページの資料で、効果的な返信テンプレートを公開。',
    keywords: 'ポータル反響,SUUMO,反響対応,メールテンプレート,来店率向上'
  },

  '/master/download/wp14': {
    title: '購入客が本当に知りたい10の質問と模範回答 | 無料ダウンロード',
    description: '顧客心理を理解した完璧な回答術。14ページの資料で、お客様の本音に寄り添う回答法を解説。',
    keywords: '顧客質問,模範回答,顧客心理,信頼構築'
  },

  '/master/download/wp15': {
    title: '信頼を勝ち取る車内トーク術 | 無料ダウンロード',
    description: '限られた移動時間を最強の営業タイムに変える方法。14ページの資料で、車内での信頼構築術を完全解説。',
    keywords: '車内トーク,移動時間,信頼構築,面談術,現地集合'
  },
  
  '/master/download/wp16': {
    title: '住宅ローン通らない客を通す裏ワザ15選 | 無料ダウンロード',
    description: '諾めていた顧客を救う実践的アプローチ。14ページの資料で、審査通過の裏ワザを完全公開。',
    keywords: '住宅ローン,審査対策,ローン承認,裏ワザ'
  },
  
  '/master/download/wp17': {
    title: '内見中やってはいけないNG行動ワースト10 | 無料ダウンロード',
    description: 'せっかくの物件を台無しにしない内見術。14ページの資料で、失敗を避ける内見マナーを解説。',
    keywords: '内見,NG行動,物件案内,失敗回避'
  },
  
  '/master/download/wp18': {
    title: '購入決断を1週間早める緊急性演出法 | 無料ダウンロード',
    description: '適切なプレッシャーで背中を押す技術。14ページの資料で、決断を促す緊急性演出法を解説。',
    keywords: '緊急性演出,決断促進,クロージング,購入決断'
  },
  
  '/master/download/wp19': {
    title: '賃貸vs購入で購入が圧勝するシミュレーション術 | 無料ダウンロード',
    description: '数字で納得させる最強の説得ツール。14ページの資料で、購入優位性を明確に証明する方法を解説。',
    keywords: '賃貸vs購入,シミュレーション,説得術,購入メリット'
  },
  
  '/master/download/wp20': {
    title: '紹介率60%を実現する購入後フォローの仕組み | 無料ダウンロード',
    description: '一度の成約が次の10件につながる方法。14ページの資料で、紹介獲得の仕組みづくりを完全解説。',
    keywords: '紹介営業,フォローアップ,顧客管理,リピート率'
  },

  '/master/download/wp27': {
    title: '初対面で信頼を築く話法 | 無料ダウンロード',
    description: '心理学に基づいた最速信頼構築テクニック。16ページの資料で、初対面から信頼を得る話法を解説。',
    keywords: '初対面,信頼構築,話法,初回面談'
  },

  // カテゴリページ
  '/master/lab/first-meeting': {
    title: '初回面談の改善 | 購入仲介ラボ',
    description: '信頼関係を構築し、確実に次回アポイントにつなげる初回面談の改善方法。具体的なテクニックと実践例を多数掲載。',
    keywords: '初回面談,面談改善,信頼関係構築,アポイント獲得'
  },
  
  '/master/lab/property-guide': {
    title: '物件案内の改善 | 購入仲介ラボ',
    description: '物件の魅力を最大限に伝え、購入意欲を高める案内術。プロの物件案内テクニックを詳しく解説。',
    keywords: '物件案内,内見,物件説明,購入意欲'
  },
  
  '/master/lab/follow-up': {
    title: 'フォローアップの改善 | 購入仲介ラボ',
    description: '検討期間中の適切なフォローで成約率を向上。タイミングと内容を最適化するフォローアップ術。',
    keywords: 'フォローアップ,追客,検討期間,成約率向上'
  },
  
  '/master/lab/closing': {
    title: 'クロージングの改善 | 購入仲介ラボ',
    description: '決断を促し、確実に成約に導くクロージング手法。購入申込獲得のための実践的テクニック集。',
    keywords: 'クロージング,成約,購入申込,決断促進'
  },
  
  '/master/contact': {
    title: 'お問い合わせ | 購入仲介マスター',
    description: '購入仲介マスターに関するご質問・ご相談はこちらから。サービスや資料についてのお問い合わせを受け付けています。',
    keywords: 'お問い合わせ,購入仲介マスター,ご相談,サポート'
  }
};

/**
 * ページのメタデータを取得
 */
export function getPageMeta(pathname) {
  // 動的ルートの処理
  if (pathname.startsWith('/master/lab/') && pathname.split('/').length > 4) {
    // 記事詳細ページ
    const category = pathname.split('/')[3];
    return {
      title: `${getCategoryName(category)}の実践ノウハウ | 購入仲介ラボ`,
      description: `${getCategoryName(category)}に関する具体的な改善方法と成功事例。現場ですぐに使える実践的なテクニックを詳しく解説。`,
      keywords: `${getCategoryName(category)},実践ノウハウ,成功事例,改善方法`
    };
  }
  
  return seoMeta[pathname] || seoMeta['/'];
}

/**
 * カテゴリ名を取得
 */
function getCategoryName(category) {
  const names = {
    'first-meeting': '初回面談',
    'property-guide': '物件案内',
    'follow-up': 'フォローアップ',
    'closing': 'クロージング'
  };
  return names[category] || category;
}

/**
 * メタタグを生成
 */
export function generateMetaTags(meta) {
  return `
    <title>${meta.title}</title>
    <meta name="description" content="${meta.description}">
    <meta name="keywords" content="${meta.keywords}">
    
    <!-- OGP -->
    <meta property="og:title" content="${meta.title}">
    <meta property="og:description" content="${meta.description}">
    <meta property="og:type" content="website">
    <meta property="og:image" content="/images/ogp-image.jpg">
    
    <!-- Twitter Card -->
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:title" content="${meta.title}">
    <meta name="twitter:description" content="${meta.description}">
    <meta name="twitter:image" content="/images/ogp-image.jpg">
  `;
}